// @ts-nocheck
import { ShareOptions } from "@insite/client-framework/Services/WishListService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addWishListToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import translate from "@insite/client-framework/Translate";
// import { CartLineCollectionModel, WishListModel } from "@insite/client-framework/Types/ApiModels"; // Foundation
import MyListsDetailsPageTypeLink from "@insite/content-library/Components/MyListsDetailsPageTypeLink";
// import WishListSharingStatus, {
//     WishListSharingStatusStyles,
// } from "@insite/content-library/Components/WishListSharingStatus"; // Foundation
// import Button, { ButtonPresentationProps } from "@insite/mobius/Button"; // Foundation
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { HiddenProps } from "@insite/mobius/Hidden";
// import { IconPresentationProps } from "@insite/mobius/Icon"; // Foundation
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
// import React, { useContext } from "react"; Foundation
import { connect, HandleThunkActionCreator } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { tableGetEllipsisCellProps } from "@store/Themes/common/props/table";
import { wishListTableProps } from "@store/Themes/common/props/wishList";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
/* Starter Custom Code - End */

/* Foundation - Start */
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import { CartLineCollectionModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import Icon, { IconMemo, IconPresentationProps, IconProps } from "@insite/mobius/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import LogOut from "@store/Library/Components/Toolkit/Icons/LogOut";
import StarFill from "@store/Library/Components/Toolkit/Icons/Star/StarFill";
import StarLine from "@store/Library/Components/Toolkit/Icons/Star/StarLine";
import TagLine from "@store/Library/Components/Toolkit/Icons/Tag/TagLine";
import Tooltip, { TooltipPresentationProps } from "@store/MobiusOverrides/Tooltip/Tooltip";
import TwoButtonModal, { TwoButtonModalStyles } from "@store/Overrides/Components/TwoButtonModal";
import { imageStyles } from "@store/Themes/common/mixins/image";
import StoreAddToCartRestrictionsMessage from "@store/Library/Components/Foundation/StoreAddToCartRestrictionsMessage";
import Trash2Fill from "@store/Library/Components/Icons/Trash2/Trash2Fill";
import WishListSharingStatus, { WishListSharingStatusStyles } from "@store/Overrides/Components/WishListSharingStatus";
import { ellipsis } from "@store/Themes/common/mixins/ellipsis";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { productTableProps } from "@store/Themes/common/props/productTable";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import React, { useContext, useState } from "react";
/* Foundation - End */

const getIconProps = (src?: IconPresentationProps["src"]): IconPresentationProps => {
    return {
        src,
        size: 20,
        color: "primary",
    };
};

const getOneLineIconProps = (
    src: IconPresentationProps["src"],
    color: string,
    hoverColor: string,
    disabled: boolean,
) => {
    return {
        src,
        size: 30,

        css: css`
            transition: all 0.2s ease-in-out;
            color: ${disabled ? getColor("text.disabled") : getColor(color)};
            &:hover {
                color: ${disabled ? getColor("text.disabled") : getColor(hoverColor)};
            }
        `,
    };
};
const actionClickable = () => css`
    ${focusStyles(true)};
    padding: ${pxToRem(10)};
`;
const mapStateToProps = (state: ApplicationState, ownProps: OwnProps /* Foundation */) => ({
    language: state.context.session.language,
    allowEditingOfWishLists: getSettingsCollection(state).wishListSettings.allowEditingOfWishLists,
    isUpdatingCart: state.context.isUpdatingCart,
    // Starter
    restrictedLines:
        getWishListLinesDataView(state, { wishListId: ownProps.wishList.id }).value?.filter(x => !x.canAddToCart) || [],
});

interface OwnProps {
    wishList: WishListModel;
    extendedStyles?: WishListCardStyles;
    addWishListToCart: HandleThunkActionCreator<typeof addWishListToCart>;
    deleteWishList?: () => void;
    leaveWishList?: () => void;
    toggleFavorite?: () => void;
    toggleHide?: () => void;
    // Starter Custom Code
    showFavorites?: boolean;
    showTags?: boolean;
    // Foundation
    showDescription?: boolean;
    // Bunzl
    oneLineView?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface WishListCardStyles {
    gridContainer?: GridContainerProps;
    wishListInfoGridItem?: GridItemProps;
    wishListInfoGridContainer?: GridContainerProps;
    basicInfoGridItem?: GridItemProps;
    basicInfoGridContainer?: GridContainerProps;
    detailLinkGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    descriptionText?: TypographyProps;
    lastUpdatedGridItem?: GridItemProps;
    lastUpdatedText?: TypographyProps;
    extendedInfoGridItem?: GridItemProps;
    extendedInfoGridContainer?: GridContainerProps;
    productImagesGridItem?: GridItemProps;
    productImageLink?: LinkPresentationProps;
    productImage?: LazyImageProps;
    sharingStatusGridItem?: GridItemProps;
    sharingStatus?: WishListSharingStatusStyles;
    actionGridItem?: GridItemProps;
    actionGridMediumHidden?: HiddenProps;
    actionOverflowIcon?: IconPresentationProps;
    actionOverflowMenu?: OverflowMenuPresentationProps;
    actionAddToCartClickable?: ClickablePresentationProps;
    actionHideClickable?: ClickablePresentationProps;
    actionDeleteClickable?: ClickablePresentationProps;
    actionLeaveClickable?: ClickablePresentationProps;
    actionAddToCartButton?: ButtonPresentationProps;
    actionHideLink?: LinkPresentationProps;
    actionDeleteButton?: ButtonPresentationProps;
    actionLeaveButton?: ButtonPresentationProps;
    actionFavoriteClickable?: ClickablePresentationProps;
    basicIconGridContainer?: GridContainerProps;
    detailIconGridItem?: GridItemProps;
    starIcon?: IconPresentationProps;
    starXIcon?: IconPresentationProps;
    tagTooltip?: TooltipPresentationProps;
    // Starter Custom Code
    iconCell?: DataTableCellProps;
    listNameDescriptionCell?: DataTableCellProps;
    dateCell?: DataTableCellProps;
    statusCell?: DataTableCellProps;
    itemsCell?: DataTableCellProps;
    itemsWrapper?: InjectableCss;
    itemsImageWrapper?: InjectableCss;
    itemProductImage?: ProductImageStyles;
    actionsCell?: DataTableCellProps;
    actionsWrapper?: InjectableCss;
    actionAddToCartLink?: LinkPresentationProps;
    actionLeaveLink?: LinkPresentationProps;
    actionDeleteLink?: LinkPresentationProps;
    actionUnhideLink?: LinkPresentationProps;
    // Foundation
    tableCellDescription?: DataTableCellProps;
    tableCellActions?: DataTableCellProps;
    tableCellActionsWrapper?: InjectableCss;
    tableCellProducts?: InjectableCss;
    tableCellProductsWrapper?: InjectableCss;
    addButton?: ButtonProps;
    trashIcon?: IconProps;
    linkWrappingImage?: InjectableCss;
    tableCellTitle?: DataTableCellProps;
    obsoleteListItemsModal?: TwoButtonModalStyles;
    removeListLineIcon?: IconPresentationProps;
    // Store Custom Code
    itemText?: TypographyProps;
    tableCellStatus?: DataTableCellProps;
}

export const wishListCardStyles: WishListCardStyles = {
    actionsWrapper: wishListTableProps.actionsWrapper,
    actionsCell: wishListTableProps.actionsCell,

    iconCell: wishListTableProps.iconCell,
    // Store Custom Code - padding added to allign with icon
    listNameDescriptionCell: {
        ...tableGetEllipsisCellProps(140),
        css: css`
            ${tableGetEllipsisCellProps(130).css}a {
                padding-top: ${pxToRem(2)};
            }
        `,
    },
    dateCell: wishListTableProps.dateCell,
    lastUpdatedText: wishListTableProps.lastUpdatedText,
    itemsCell: wishListTableProps.itemsCell,
    itemsWrapper: wishListTableProps.itemsWrapper,
    itemsImageWrapper: wishListTableProps.itemsImageWrapper,
    itemProductImage: wishListTableProps.itemProductImage,
    // Store Custom Code
    statusCell: tableGetEllipsisCellProps(140),
    actionAddToCartLink: {
        // Store Custom Code - colors are nice
        ...productLineProps.addToListLink,
        css: css`
            ${productLineProps.addToListLink?.css}
            &:not(disabled) {
                color: ${getColor("primary")};
                &:hover {
                    color: ${getColor("primary")};
                }
            } ;
        `,
    },
    actionLeaveLink: wishListTableProps.actionLeaveLink,
    // Store Custom Code - colors are nice
    actionDeleteLink: {
        ...productLineProps.removeLink,

        css: css`
            ${productLineProps.removeLink?.css}
            &:not(disabled) {
                color: ${getColor("text.milanoRed")};
                &:hover {
                    color: ${getColor("text.milanoRed")};
                }
            } ;
        `,
    },
    actionHideLink: wishListTableProps.actionHideLink,
    actionUnhideLink: wishListTableProps.actionUnhideLink,
    tableCellStatus: tableGetEllipsisCellProps(110),
    itemText: {
        css: css`
            padding-left: 1.5rem;
            color: ${getColor("secondary")};
        `,
    },
    gridContainer: {
        gap: 5,
    },
    wishListInfoGridItem: {
        width: [10, 10, 8, 10, 10],
        align: "middle",
    },
    basicInfoGridItem: { width: [12, 12, 5, 4, 4] },
    basicInfoGridContainer: {
        gap: 10,
    },
    detailLinkGridItem: { width: 12 },
    descriptionGridItem: { width: 12 },
    descriptionText: { ellipsis: true },
    lastUpdatedGridItem: { width: 12 },
    extendedInfoGridItem: {
        width: [12, 12, 7, 8, 8],
        align: "middle",
    },
    productImageLink: {
        css: css`
            ${({ theme }) => imageStyles(theme.design.product.image.medium.ratio)}
            width: ${pxToRem(65)};
        `,
    },
    productImagesGridItem: {
        width: [12, 12, 12, 8, 8],
        css: css`
            flex-wrap: wrap;
        `,
    },
    productImage: {
        css: css`
            max-width: ${pxToRem(75)};
            img {
                height: 100%;
            }
        `,
        errorTypographyProps: {
            size: 11,
            css: css`
                max-height: ${pxToRem(65)};
            `,
        },
    },
    sharingStatusGridItem: { width: [12, 12, 12, 3, 3] },
    sharingStatus: {
        privateTooltip: {
            cssOverrides: {
                tooltipWrapper: css`
                    margin-left: 0.25em;
                `,
            },
        },
        statusText: {
            css: css`
                display: flex;
                align-items: center;
                min-width: ${pxToRem(100)};
                > span {
                    ${ellipsis(pxToRem(150))}
                }
            `,
        },
    },
    actionGridItem: {
        width: [2, 2, 4, 2, 2],
        align: "top",
        css: css`
            justify-content: flex-end;
        `,
    },
    actionGridMediumHidden: {
        css: css`
            width: 100%;
        `,
    },
    actionAddToCartButton: {
        css: css`
            ${({ theme }) => theme?.button?.primary?.css}
            min-width: 0;
            padding: 0 ${pxToRem(15)};
            margin-right: 0.5em;
        `,
    },
    actionDeleteButton: {
        color: "danger.light",
        css: css`
            ${({ theme }) => theme?.button?.defaultProps?.css}
            margin-left: ${pxToRem(5)};
            min-width: 0;
            padding: 0 ${pxToRem(5)};
        `,
    },
    actionLeaveButton: {
        variant: "secondary",
        css: css`
            width: 100%;
            margin-top: ${pxToRem(30)};
        `,
    },
    // Store Custom Code
    tableCellDescription: {
        css: css`
            ${ellipsis(pxToRem(150))}
        `,
    },
    tableCellActions: {
        ...productTableProps.tableCellControls,
        css: css`
            ${productTableProps.tableCellControls?.css} padding-right: 1rem;
        `,
    },
    tableCellActionsWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
        `,
    },
    tableCellProducts: productTableProps.tableCellControls,
    tableCellProductsWrapper: {
        css: css`
            display: flex;
        `,
    },
    trashIcon: {
        src: Trash2Fill,
        color: "danger",
    },
    linkWrappingImage: {
        css: css`
            position: relative;
            margin-right: ${pxToRem(5)};
        `,
    },
    tableCellTitle: {
        css: css`
            ${TypographyStyle} {
                ${ellipsis(pxToRem(150))}
            }
        `,
    },
    removeListLineIcon: productLineProps.removeProductLineIcon,

    actionFavoriteClickable: {
        css: css`
            ${actionClickable()}
        `,
    },
    starIcon: getIconProps(StarLine),
    starXIcon: getIconProps(StarFill),
    tagTooltip: {
        iconProps: getIconProps(TagLine),
        cssOverrides: {
            tooltipContainer: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipContainer}
                bottom: 80%;
                left: 5px;
                justify-content: flex-start;
                transform: none;
            `,
            tooltipArrow: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipArrow}
                left: 7%;
            `,
            tooltipWrapper: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipWrapper}
                margin-left: 0;
            `,
            tooltipClickable: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipClickable}
                ${actionClickable()}
            `,
        },
    },
};

const WishListCard = ({
    language,
    allowEditingOfWishLists,
    isUpdatingCart,
    extendedStyles,
    wishList,
    addWishListToCart,
    deleteWishList,
    leaveWishList,
    toggleFavorite,
    toggleHide,
    // Starter Custom Code
    showFavorites,
    showTags,
    // Foundation
    restrictedLines,
    showDescription,
    // Store Custom Code
    oneLineView,
}: Props) => {
    const isHidden = wishList.isHidden;
    const toasterContext = useContext(ToasterContext);
    const isLoadingAnyList = useAppSelector(state => Object.keys(state.data.wishLists.isLoading).length > 0);
    // Store Custom Code
    const [isHovering, setIsHovering] = useState(false);

    /* Foundation - Start */
    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
    /* Foundation - End */
    /* Starter Custom Code - Start */
    const trackAddWishListToCart = ga.use.trackAddWishListToCart({}, { wishList });
    const trackAddToCart = ga.use.trackAddToCart({}, { wishList });
    /* Starter Custom Code - End */

    const clickAddToCartHandler = (e: any, hasConfirm = false /* Foundation */) => {
        e.preventDefault();

        /* Foundation - Start */
        if (restrictedLines.length && !hasConfirm) {
            setConfirmModalIsOpen(true);
            return;
        }
        /* Foundation - End */

        addWishListToCart({
            apiParameter: { wishListId: wishList.id },
            onSuccess: onAddAllToCartSuccess,
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps.apiResult);
                } else if (resultProps.errorMessage) {
                    toasterContext.addToast({
                        body: resultProps.errorMessage,
                        messageType: "danger",
                    });
                }
            },
        });
    };
    const toggleHideHandler = () => {
        if (!toggleHide) {
            return;
        }
        toasterContext.addToast({
            body: wishList.isHidden
                ? siteMessage("Lists_Items_Unhide_Success")
                : siteMessage("Lists_Items_Hide_Success"),
            messageType: "success",
        });
        toggleHide?.();
    };
    /* Foundation - Start */
    const addToCartCancelHandler = () => {
        setConfirmModalIsOpen(false);
    };
    const addToCartSubmitHandler = (e: any) => {
        setConfirmModalIsOpen(false);
        clickAddToCartHandler(e, true);
    };
    /* Foundation - End */

    const onAddAllToCartSuccess = (result: CartLineCollectionModel) => {
        /* Starter Custom Code - Start */
        trackAddWishListToCart();
        trackAddToCart();
        /* Starter Custom Code - End */
        toasterContext.addToast({
            body: result.notAllAddedToCart
                ? siteMessage("Lists_Items_Not_All_Added_To_Cart")
                : translate("List Added to Cart"),
            messageType: "success",
        });
    };

    // bunzl deleted code - updated on display

    const canAddToCart =
        wishList.canAddToCart &&
        !!wishList.properties.wishListLineCount &&
        Number(wishList.properties.wishListLineCount) > 0;
    const addToCartLabel = translate("Add List to Cart");
    const deleteLabel = translate("Delete");
    const leaveLabel = translate("Leave List");
    const styles = useMergeProps(wishListCardStyles, extendedStyles); // Starter Custom Code

    /* bunzl deleted code */

    const hiddenIcon = isHidden && isHovering ? Eye : isHidden && !isHovering ? EyeOff : isHovering ? EyeOff : Eye;
    const showFavouriteTagColumn = (showFavorites || showTags) && !oneLineView;

    const toggleHideButtonText = isHidden ? translate("Unhide List") : translate("Hide List");
    const toggleHideButtonStyles = isHidden ? styles.actionUnhideLink : styles.actionHideLink; // Starter Custom Code
    const tagsText = wishList.wishListTags
        ? wishList.wishListTags.length > 1
            ? translate("Tags Assigned")
            : translate("Tag Assigned")
        : undefined;
    return (
        <DataTableRow data-test-selector="wishListCard">
            {showFavouriteTagColumn && (
                <DataTableCell {...styles.iconCell}>
                    {!wishList.isAutogenerated && (
                        <Clickable
                            {...styles.actionFavoriteClickable}
                            onClick={toggleFavorite}
                            data-test-selector={`myListsFavorite_${wishList.id}`}
                            disabled={isLoadingAnyList}
                        >
                            {wishList.isFavorite && (
                                <Icon
                                    {...styles.starXIcon}
                                    data-test-selector={`myListsFavoriteStarXIcon_${wishList.id}`}
                                    title={translate("Remove from my favorites")}
                                />
                            )}
                            {!wishList.isFavorite && (
                                <Icon
                                    {...styles.starIcon}
                                    data-test-selector={`myListsFavoriteStarIcon_${wishList.id}`}
                                    title={translate("Add to my favorites")}
                                />
                            )}
                        </Clickable>
                    )}
                    {showTags && (
                        <Tooltip
                            {...styles.tagTooltip}
                            text={
                                wishList.wishListTags?.length
                                    ? `${translate("{0}:", translate("Tags Assigned"))} ${wishList.wishListTags
                                          .map(o => o.tag)
                                          .join(", ")}`
                                    : translate("No Tags Assigned")
                            }
                            triggerAltText={tagsText}
                            clickableTitle={tagsText}
                        />
                    )}
                    {wishList.isAutogenerated && (!wishList.wishListTags || !wishList.wishListTags?.length) && (
                        <VisuallyHidden>{translate("No actions available for this list")}</VisuallyHidden>
                    )}
                </DataTableCell>
            )}
            <DataTableCell {...styles.listNameDescriptionCell}>
                <StyledWrapper
                    css={css`
                        display: flex;
                        gap: 0.5rem;
                    `}
                >
                    {oneLineView && !wishList.isAutogenerated && (
                        <Clickable
                            {...styles.actionFavoriteClickable}
                            onClick={toggleFavorite}
                            data-test-selector={`myListsFavorite_${wishList.id}`}
                            disabled={isLoadingAnyList}
                        >
                            {wishList.isFavorite && (
                                <Icon
                                    {...styles.starXIcon}
                                    data-test-selector={`myListsFavoriteStarXIcon_${wishList.id}`}
                                    title={translate("Remove from my favorites")}
                                />
                            )}
                            {!wishList.isFavorite && (
                                <Icon
                                    {...styles.starIcon}
                                    data-test-selector={`myListsFavoriteStarIcon_${wishList.id}`}
                                    title={translate("Add to my favorites")}
                                />
                            )}
                        </Clickable>
                    )}

                    <MyListsDetailsPageTypeLink
                        title={wishList.name}
                        wishListId={wishList.id}
                        testSelector="wishListCardName"
                    />
                    {wishList.wishListTags && wishList.wishListTags.length > 0 && (
                        <Tooltip
                            {...styles.tagTooltip}
                            text={`${translate("Tags Assigned")}: ${wishList.wishListTags.map(o => o.tag).join(", ")}`}
                            triggerAltText={tagsText}
                            clickableTitle={tagsText}
                        />
                    )}
                </StyledWrapper>
            </DataTableCell>
            {showDescription && (
                <DataTableCell {...styles.tableCellDescription}>
                    <Typography {...styles.descriptionText} data-test-selector="wishListCardDescription">
                        {wishList?.description ?? ""}
                    </Typography>
                </DataTableCell>
            )}
            {/* Bunzl deleted Code don't show last update */}

            <DataTableCell {...styles.tableCellProducts}>
                <Typography {...styles.itemText}>{wishList.properties?.wishListLineCount}</Typography>
            </DataTableCell>
            <DataTableCell {...styles.tableCellStatus}>
                <WishListSharingStatus removeTooltip extendedStyles={styles.sharingStatus} wishList={wishList} />
            </DataTableCell>
            {/* Store Custom Code - one line view Start */}
            <DataTableCell {...styles.tableCellActions}>
                {oneLineView && (
                    <StyledWrapper
                        css={css`
                            display: flex;
                            gap: 0.5rem;
                        `}
                    >
                        <Button
                            {...styles.actionAddToCartButton}
                            disabled={!canAddToCart || isUpdatingCart}
                            data-test-selector={`wishListAddToCartButton_${wishList.id}`}
                            onClick={clickAddToCartHandler}
                        >
                            {addToCartLabel}
                        </Button>
                        <Clickable
                            onMouseEnter={() => setIsHovering(true)}
                            onMouseLeave={() => setIsHovering(false)}
                            onClick={toggleHideHandler}
                            disabled={isLoadingAnyList}
                        >
                            <IconMemo {...getOneLineIconProps(hiddenIcon, "primary", "secondary", isLoadingAnyList)} />
                            <VisuallyHidden>{toggleHideButtonText}</VisuallyHidden>
                        </Clickable>
                        {allowEditingOfWishLists &&
                        !!leaveWishList &&
                        wishList.isSharedList &&
                        wishList.shareOption !== ShareOptions.AllCustomerUsers ? (
                            <Clickable
                                onClick={leaveWishList}
                                disabled={!(allowEditingOfWishLists && !wishList.isSharedList)}
                            >
                                <IconMemo
                                    {...getOneLineIconProps(
                                        LogOut,
                                        "text.milanoRed",
                                        "danger",
                                        !(allowEditingOfWishLists && !wishList.isSharedList),
                                    )}
                                />
                                <VisuallyHidden>{translate("Leave this wishlist")}</VisuallyHidden>
                            </Clickable>
                        ) : (
                            <Clickable
                                onClick={deleteWishList}
                                data-test-selector={`wishListCardDeleteButton_${wishList.id}`}
                                disabled={!(allowEditingOfWishLists && !wishList.isSharedList)}
                            >
                                <IconMemo
                                    {...getOneLineIconProps(
                                        Trash2Fill,
                                        "text.milanoRed",
                                        "danger",
                                        !(allowEditingOfWishLists && !wishList.isSharedList),
                                    )}
                                />
                                <VisuallyHidden>{translate("Delete this wishlist")}</VisuallyHidden>
                            </Clickable>
                        )}
                    </StyledWrapper>
                )}
                {!oneLineView && (
                    <StyledWrapper {...styles.actionsWrapper}>
                        <Link
                            {...styles.actionAddToCartLink}
                            disabled={!canAddToCart || isUpdatingCart}
                            onClick={clickAddToCartHandler}
                        >
                            {addToCartLabel}
                        </Link>
                        {allowEditingOfWishLists &&
                        !!leaveWishList &&
                        wishList.isSharedList &&
                        wishList.shareOption !== ShareOptions.AllCustomerUsers ? (
                            <Link {...styles.actionLeaveLink} onClick={leaveWishList}>
                                {leaveLabel}
                            </Link>
                        ) : (
                            <Link
                                {...styles.actionDeleteLink}
                                disabled={
                                    !deleteWishList ||
                                    wishList.isSharedList ||
                                    !allowEditingOfWishLists ||
                                    wishList.isAutogenerated
                                }
                                onClick={deleteWishList}
                                data-test-selector={`wishListCardDeleteButton_${wishList.id}`}
                            >
                                {deleteLabel}
                            </Link>
                        )}
                        {!wishList.isAutogenerated && (
                            <Link
                                onMouseEnter={() => setIsHovering(true)}
                                onMouseLeave={() => setIsHovering(false)}
                                {...toggleHideButtonStyles}
                                disabled={isLoadingAnyList}
                                onClick={toggleHideHandler}
                            >
                                {toggleHideButtonText}
                            </Link>
                        )}
                    </StyledWrapper>
                )}
                {/* Store Custom Code - one line view end */}
                {/* Foundation - Start */}
                <TwoButtonModal
                    headlineText={translate("Add to Cart")}
                    modalIsOpen={confirmModalIsOpen}
                    messageText={
                        <StoreAddToCartRestrictionsMessage list={restrictedLines.map(x => x.shortDescription)} />
                    }
                    cancelButtonText={translate("Cancel")}
                    submitButtonText={translate("Continue")}
                    onCancel={addToCartCancelHandler}
                    onSubmit={addToCartSubmitHandler}
                />
                {/* Foundation - End */}
            </DataTableCell>
        </DataTableRow>
    );
};

export default connect(mapStateToProps)(WishListCard);
